import React from 'react';
import { useState } from 'react';
import withAuth from '../../HOCs/withAuth';
import SortedByModal from '../modals/sorted-by-modal';
import PublicTripsNavBar from '../navbars/public-trips-navbar';
import {
  SortByTitleAsc,
  SortByLastUpdateRecentFirst
} from '../../Models/sortby.model';
import {
  PublicTripsProvider,
  usePublicTrips
} from '../contexts/public-trips-context';
import { SortingProvider, useSorting } from '../contexts/sorting-context';
import { ModalProvider } from '../contexts/modal-context';
import { PaginationProvider } from '../contexts/pagination-context';
import PublicTripCardList from '../trips/public-trip-card-list';

function PublicTripsPage() {
  const [showDisplaySortByModal, setShowSortByModal] = useState(false);
  const { sort, setSort } = useSorting();
  const { setRefreshPublicTrips, searchQuery, setSearchQuery } =
    usePublicTrips();

  const handleSortByStateChange = (state: boolean) => {
    setShowSortByModal(state);
  };

  const handleCloseSortBy = () => {
    setShowSortByModal(false);
  };

  const handleSearchChange = (value: string) => {
    setSearchQuery(value);
    // Clear search and refresh if value is empty
    if (!value || value.trim() === '') {
      setRefreshPublicTrips(true);
    }
  };

  const handleSearchSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    console.log('🔍 Search submitted with query:', searchQuery);
    // Trigger refresh with search query
    setRefreshPublicTrips(true);
  };

  return (
    <>
      <div className='gradient-bg-login gradient-bg-decoration'></div>
      <div className='overflow-y-auto page-scroll-container'>
        <div className='container-px'>
          <PublicTripsNavBar
            onSortByStateChange={handleSortByStateChange}
            searchQuery={searchQuery}
            onSearchChange={handleSearchChange}
            onSearchSubmit={handleSearchSubmit}
          />
          <PublicTripCardList
            direction='horizontal'
            searchQuery={searchQuery}
          />
          <SortedByModal
            show={showDisplaySortByModal}
            handleClose={handleCloseSortBy}
            dataSort={[
              { value: SortByTitleAsc, label: 'From A to Z' },
              { value: SortByLastUpdateRecentFirst, label: 'Newest' }
            ]}
            setSortBy={setSort}
          />
        </div>
      </div>
    </>
  );
}

const PublicTripsPageWithProvider: React.FC = () => {
  return (
    <PublicTripsProvider>
      <PaginationProvider>
        <SortingProvider>
          <ModalProvider>
            <PublicTripsPage />
          </ModalProvider>
        </SortingProvider>
      </PaginationProvider>
    </PublicTripsProvider>
  );
};

export default withAuth(PublicTripsPageWithProvider);
